// Hardcoded list of hiring stages for filter presets
export const defaultHiringStages = [
  { name: 'LEAD' },
  { name: 'APPLICATION' },
  { name: 'QUALIFICATION' },
  { name: 'ONBOARDING' },
]

// Default column visibility configuration
export const defaultColumnVisibility = {
  select: true,
  applicant: true,
  position: true,
  leadSource: false,
  employees: false,
  contact: true,
  email: false,
  calls: true,
  missedCalls: false,
  applied: true,
  lastContact: false,
  hired: false,
  terminated: false,
  disqualified: false,
  notInterested: false,
  availableForWork: false,
  stage: true,
  experience: true,
  location: true,
  actions: true,
}

// Default column order
export const defaultColumnOrder = [
  'select',
  'applicant',
  'position',
  'leadSource',
  'employees',
  'contact',
  'email',
  'calls',
  'missedCalls',
  'applied',
  'lastContact',
  'hired',
  'terminated',
  'disqualified',
  'notInterested',
  'stage',
  'experience',
  'location',
  'actions',
  'availableForWork',
]

// Default sort configuration
export const defaultSortByConfig = [
  {
    sortBy: 'APPLICATION_DATE',
    direction: 'DESC' as const,
  },
]

// Helper function to transform sort config for GraphQL
// Converts CUSTOM_FIELD_xxx format to proper customFieldId parameter
export const transformSortConfigForGraphQL = (
  sortConfig: Array<{ sortBy: string; direction: 'ASC' | 'DESC' }>
) => {
  return sortConfig.map((sort) => {
    if (sort.sortBy.startsWith('CUSTOM_FIELD_')) {
      // Extract custom field ID from CUSTOM_FIELD_xxx format
      const customFieldId = sort.sortBy.replace('CUSTOM_FIELD_', '')
      return {
        customFieldId,
        direction: sort.direction,
      }
    }
    // Standard field - return as is
    return {
      sortBy: sort.sortBy,
      direction: sort.direction,
    }
  })
}

// CSV download limit
export const LIMIT_CSV = 500
